<ng-container *ngIf="landOwner" [formGroup]="landOwner">
  <h4 class="wizard-h3">Are you the landowner?</h4>
  <p class="fine-print">
    This information is so the owner can be contacted for validation if necessary and will not be shown to guests.
  </p>
  <div class="landowner-center accordion">
    <div class="landowner-wrapper">
      <button
        class="cnt-button"
        (click)="selfHosting = true"
        [ngClass]="{ active: selfHosting }"
        type="button"
        data-test="landowner-self-hosting-yes"
      >
        <div class="cnt-button-copy">Yes</div>
      </button>
      <button
        class="cnt-button"
        (click)="selfHosting = false"
        [ngClass]="{ active: selfHosting === false }"
        type="button"
        data-test="landowner-self-hosting-no"
      >
        <div class="cnt-button-copy">No</div>
      </button>
    </div>
  </div>
  <p *ngIf="landOwnerError" class="alert-danger">
    <i class="icon-cnt-times-circle"></i>
    {{ landOwnerError }}
  </p>
  <div *ngIf="editView === true && !selfHosting && selfHosting !== false">
    <div class="_18-px-spacer"></div>
    <div class="alert-danger">Please complete the &ldquo;Are you the landowner?&rdquo; section above.</div>
  </div>

  <ng-container *ngIf="selfHosting === false && !boondocking">
    <div class="_18-px-spacer"></div>
    <h4>What type of land is it?</h4>
    <div class="_12-px-spacer"></div>
    <div class="landowner-center accordion">
      <div class="landowner-wrapper">
        <button class="cnt-button" (click)="privateHosting = true" [ngClass]="{ active: privateHosting }" type="button">
          <div class="cnt-button-copy">Private</div>
        </button>
        <button
          class="cnt-button"
          (click)="privateHosting = false"
          [ngClass]="{ active: privateHosting === false }"
          type="button"
        >
          <div class="cnt-button-copy">Public</div>
        </button>
      </div>
    </div>
    <p *ngIf="privateHostingError" class="alert-danger">
      <i class="icon-cnt-times-circle"></i>
      {{ privateHostingError }}
    </p>
  </ng-container>
  <ng-container *ngIf="selfHosting === false">
    <div class="_18-px-spacer"></div>
    <h4 *ngIf="privateHosting === false || privateHosting || boondocking">Who is the landowner?</h4>
    <input
      class="text-input w-input landowner-boondock-owner"
      *ngIf="privateHosting === false || boondocking"
      [formControl]="lastName"
      data-test="landowner-input-field"
      placeholder="BLM, Forest Service, etc..."
    />
    <p *ngIf="landOwnerNameError" class="alert-danger">
      <i class="icon-cnt-times-circle"></i>
      {{ landOwnerNameError }}
    </p>

    <div *ngIf="privateHosting">
      <label for="landOwnerFirstName"> First Name </label>
      <input type="text" formControlName="firstName" id="landOwnerFirstName" class="text-input w-input" />
      <label for="landOwnerLastName"> Last Name </label>
      <input type="text" formControlName="lastName" id="landOwnerLastName" class="text-input w-input" />
      <label for="landOwnerPhone"> Phone </label>
      <input type="text" formControlName="phone" id="landOwnerPhone" class="text-input w-input" cntMaskPhone />
      <div formGroupName="address">
        <label for="address">Address</label>
        <input id="address" type="text" formControlName="address" class="text-input w-input" />
        <label for="city">City</label>
        <input id="city" type="text" formControlName="city" class="text-input w-input" />
        <label for="state">State</label>
        <input id="state" type="text" formControlName="state" class="text-input w-input" />
        <label for="zipcode">ZIP Code</label>
        <input id="zipcode" type="text" formControlName="zipcode" class="text-input w-input" />
      </div>
      <p *ngIf="privateOwnerDetailsError && privateHosting === true" class="alert-danger">
        <i class="icon-cnt-times-circle"></i>
        {{ privateOwnerDetailsError }}
      </p>
    </div>
  </ng-container>
  <ng-container *ngIf="selfHosting === false && !boondocking">
    <h4>Do you represent the landowner?</h4>
    <div class="_12-px-spacer"></div>
    <div class="landowner-center accordion">
      <div class="landowner-wrapper">
        <button class="cnt-button" (click)="represent = true" [ngClass]="{ active: represent }" type="button">
          <div class="cnt-button-copy">Yes</div>
        </button>
        <button
          class="cnt-button"
          (click)="represent = false"
          [ngClass]="{ active: represent === false }"
          type="button"
        >
          <div class="cnt-button-copy">No</div>
        </button>
      </div>
    </div>
    <p *ngIf="representError" class="alert-danger">
      <i class="icon-cnt-times-circle"></i>
      {{ representError }}
    </p>
  </ng-container>
</ng-container>
